import React from 'react'

export function browse() {
  return (
    <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>owners manual</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-312.000000, -31.000000)">
          <g transform="translate(312.000000, 31.000000)">
            <rect x="0" y="0" width="24" height="24"></rect>
            <path d="M21.7574644,2.0303501 C22.3886111,1.87256342 23,2.34992145 23,3.0004926 L23,3.0004926 L23,18.5004926 C23,18.9593602 22.6877026,19.3593434 22.2425356,19.4706351 L22.2425356,19.4706351 L12.2425356,21.9706351 C12.0832956,22.0104451 11.9167044,22.0104451 11.7574644,21.9706351 L11.7574644,21.9706351 L1.75746437,19.4706351 C1.31229737,19.3593434 1,18.9593602 1,18.5004926 L1,18.5004926 L1,3.0004926 C1,2.34992145 1.6113889,1.87256342 2.24253563,2.0303501 L2.24253563,2.0303501 L12,4.4684926 Z M3,4.2814926 L3,17.7194926 L11,19.718 L11,6.281 L3,4.2814926 Z M21,4.2814926 L17,5.281 L17,8.0004926 C17,8.55277735 16.5522847,9.0004926 16,9.0004926 C15.4871642,9.0004926 15.0644928,8.61445241 15.0067277,8.11711373 L15,8.0004926 L15,5.781 L13,6.281 L13,19.718 L21,17.7184926 L21,4.2814926 Z" fill="#6E6E6E" fillRule="nonzero"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}
